import {
  addDays,
  isBefore,
  isValid,
  isWeekend,
  parse,
  startOfDay,
} from "date-fns";

export const DATE_ONLY_FORMAT = "yyyy-MM-dd";
const LUNCH_BOX_ORDER_CUTOFF_HOUR = 13;
export const MIN_BUSINESS_DAYS_FOR_LUNA_BOX = 2;
export const MIN_BUSINESS_DAYS_FOR_NON_LUNA_BOX = 5;
export const MIN_BUSINESS_DAYS_FOR_LUNCH_BOX_CANCELLATION = 2;

const getNextBusinessDay = (date: Date) => {
  let businessDay = startOfDay(date);

  while (isWeekend(businessDay)) {
    businessDay = addDays(businessDay, 1);
  }

  return businessDay;
};

const isAfterLunchBoxOrderCutoff = (date: Date) => {
  if (date.getHours() > LUNCH_BOX_ORDER_CUTOFF_HOUR) {
    return true;
  }

  if (date.getHours() < LUNCH_BOX_ORDER_CUTOFF_HOUR) {
    return false;
  }

  return (
    date.getMinutes() > 0 || date.getSeconds() > 0 || date.getMilliseconds() > 0
  );
};

const getEffectiveLunchBoxOrderDate = (orderedAt: Date) => {
  let effectiveDate = startOfDay(orderedAt);

  if (isAfterLunchBoxOrderCutoff(orderedAt)) {
    effectiveDate = addDays(effectiveDate, 1);
  }

  while (isWeekend(effectiveDate)) {
    effectiveDate = addDays(effectiveDate, 1);
  }

  return effectiveDate;
};

const getBusinessDaysBetweenExclusive = (startDate: Date, endDate: Date) => {
  let count = 0;
  let cursor = addDays(startDate, 1);

  while (isBefore(cursor, endDate)) {
    if (!isWeekend(cursor)) {
      count += 1;
    }
    cursor = addDays(cursor, 1);
  }

  return count;
};

export const getMinBusinessDaysForLunchBox = (isLunaBox: boolean) =>
  isLunaBox
    ? MIN_BUSINESS_DAYS_FOR_LUNA_BOX
    : MIN_BUSINESS_DAYS_FOR_NON_LUNA_BOX;

export const hasEnoughBusinessDaysBeforeLunchBoxDelivery = (
  deliveryDate: string,
  orderedAt: Date,
  minBusinessDays: number,
) => {
  const parsedDeliveryDate = parse(deliveryDate, DATE_ONLY_FORMAT, new Date());

  if (!isValid(parsedDeliveryDate)) {
    return false;
  }

  if (isWeekend(parsedDeliveryDate)) {
    return false;
  }

  const effectiveOrderDate = getEffectiveLunchBoxOrderDate(orderedAt);
  const normalizedDeliveryDate = startOfDay(parsedDeliveryDate);

  const businessDaysBetween = getBusinessDaysBetweenExclusive(
    effectiveOrderDate,
    normalizedDeliveryDate,
  );

  return businessDaysBetween >= minBusinessDays;
};

export const hasEnoughBusinessDaysBeforeLunchBoxCancellation = (
  deliveryDate: string,
  cancelledAt: Date,
) =>
  hasEnoughBusinessDaysBeforeLunchBoxDelivery(
    deliveryDate,
    cancelledAt,
    MIN_BUSINESS_DAYS_FOR_LUNCH_BOX_CANCELLATION,
  );

export const getMinLunchBoxDeliveryDate = (
  orderedAt: Date,
  minBusinessDays: number,
) => {
  let candidateDate = getEffectiveLunchBoxOrderDate(orderedAt);
  let businessDaysBetween = 0;

  while (businessDaysBetween < minBusinessDays) {
    candidateDate = addDays(candidateDate, 1);
    if (!isWeekend(candidateDate)) {
      businessDaysBetween += 1;
    }
  }

  return getNextBusinessDay(addDays(candidateDate, 1));
};
